export default __webpack_public_path__ + "static/9-490a40abf345f14a7984b55dc678a3c9.jpg";